import { createNamespacedHelpers } from 'vuex';
import {
  CALENDAR_SET,
  CALENDAR_CHIUSURE,
} from '@/store/types';

const { mapGetters, mapMutations } = createNamespacedHelpers('Session');
const { mapActions: mapStatActions } = createNamespacedHelpers('Stats');

export default {
  methods: {
    ...mapMutations({
      calendarSet: CALENDAR_SET,
    }),
    ...mapStatActions({
      loadChiusure: CALENDAR_CHIUSURE,
    }),
  },
  computed: {
    ...mapGetters([
      'yearmin',
      'yearmax',
      'calendar',
    ]),
  },
};
